import { render, staticRenderFns } from "./collectionAccount.vue?vue&type=template&id=2cb92b20&scoped=true"
import script from "./collectionAccount.vue?vue&type=script&lang=js"
export * from "./collectionAccount.vue?vue&type=script&lang=js"
import style0 from "./collectionAccount.vue?vue&type=style&index=0&id=2cb92b20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb92b20",
  null
  
)

export default component.exports